export default __webpack_public_path__ + "static/media/profile.991e6d2c.jpg";